var _circle, _circle2, _circle3, _rect, _rect2, _rect3, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveDealer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 13,
    fill: "#065f46",
    stroke: "#10b981",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 9,
    fill: "none",
    stroke: "#34d399",
    strokeWidth: 1,
    strokeDasharray: "3 2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 5,
    fill: "#10b981"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 8,
    height: 11,
    rx: 1.5,
    fill: "#1e293b",
    stroke: "#6366f1",
    strokeWidth: 1,
    transform: "rotate(-15 16 15)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 9,
    width: 8,
    height: 11,
    rx: 1.5,
    fill: "#0f172a",
    stroke: "#818cf8",
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 8,
    height: 11,
    rx: 1.5,
    fill: "#1e293b",
    stroke: "#6366f1",
    strokeWidth: 1,
    transform: "rotate(15 24 15)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 18,
    y: 18,
    fontFamily: "Arial",
    fontSize: 6,
    fontWeight: "bold",
    fill: "white"
  }, "A")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveDealer);
export default __webpack_public_path__ + "static/media/live-dealer.4868f9de7f8b31cd5e8a5699b29186fe.svg";
export { ForwardRef as ReactComponent };